// Photo-proof helpers: fresh shutter-time GPS + device timezone.

export function deviceTz() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "";
  } catch (e) {
    return "";
  }
}

// Fresh high-accuracy fix. maximumAge: 0 means the browser may NOT return a
// cached/stale position — a fix is only useful as proof when it is fresh.
export function acquireFreshPosition({ timeoutMs = 12000 } = {}) {
  return new Promise((resolve) => {
    if (!navigator.geolocation) return resolve({ error: "unavailable" });
    navigator.geolocation.getCurrentPosition(
      (p) => resolve({
        lat: p.coords.latitude,
        lng: p.coords.longitude,
        accuracy: p.coords.accuracy,
        fix_ts: p.timestamp || Date.now(),
      }),
      (err) => resolve({ error: err?.code === 1 ? "denied" : err?.code === 2 ? "unavailable" : "timeout" }),
      { timeout: timeoutMs, enableHighAccuracy: true, maximumAge: 0 }
    );
  });
}

// A fix counts as shutter-time proof only when it was taken within this window
// of the shutter press. Anything older is honestly "location not captured".
export const FIX_FRESH_MS = 60000;

export function freshEnough(fix, shotTsMs) {
  return !!(fix && fix.lat != null && Math.abs((shotTsMs || Date.now()) - fix.fix_ts) <= FIX_FRESH_MS);
}
